import { css, Rule } from 'glamor'
import * as React from 'react'
import * as PropTypes from 'prop-types'

import { isKey } from '../../utils'
import { Theme } from '../../theme'

import getStyles from './styles'

export const sizes = {
  xSmall: '13px',
  small: '20px',
  medium: '30px',
  large: '40px',
  xLarge: '50px',
}
const themes = ['light', 'dark', 'blue']

interface ILoaderProps {
  size: 'xSmall' | 'small' | 'medium' | 'large' | 'xLarge' | string
  theme: 'light' | 'dark' | 'blue'
  showAfterMs: number
  style?: Rule
  padding?: string
}

export class Loader extends React.Component<ILoaderProps> {
  static propTypes = {
    size: PropTypes.oneOfType([PropTypes.oneOf(Object.keys(sizes)), PropTypes.string]),
    theme: PropTypes.oneOf(themes),
    showAfterMs: PropTypes.number,
    style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    padding: PropTypes.string,
  }

  static defaultProps = {
    showAfterMs: 500,
    size: 'medium',
    theme: 'blue',
  }

  state = { showLoader: this.props.showAfterMs === 0 }

  componentDidMount() {
    if (!this.state.showLoader) {
      this.timer = window.setTimeout(() => this.setState({ showLoader: true }), this.props.showAfterMs)
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      window.clearTimeout(this.timer)
    }
  }

  timer?: number

  render() {
    const { theme, size, padding, style } = this.props
    const sizeStyle = isKey(sizes, size)
      ? {
          width: sizes[size],
          height: sizes[size],
        }
      : {
          width: size,
          height: size,
        }

    const paddingStyles = padding ? { padding } : null

    return this.state.showLoader ? (
      <Theme>
        {uiTheme => {
          const styles = getStyles(uiTheme)

          return (
            <i {...css([styles.loader.base, sizeStyle, paddingStyles, style])}>
              <svg {...css(styles.spinner.base)} viewBox="0 0 50 50">
                <circle
                  cx="25"
                  cy="25"
                  fill="none"
                  r="20"
                  stroke={
                    theme === 'blue'
                      ? uiTheme.colors.accents.primary
                      : theme === 'dark'
                      ? uiTheme.colors.ui.dark
                      : uiTheme.colors.ui.white
                  }
                  strokeWidth={5}
                  {...css(styles.circle.base)}
                />
              </svg>
            </i>
          )
        }}
      </Theme>
    ) : null
  }
}

;(Loader as any).SIZES = Object.keys(sizes)
;(Loader as any).THEMES = themes
